import styled, { css, keyframes } from 'styled-components';

interface LoadingWrapperProps {
  isInner?: boolean;
  backgroundOnly?: boolean;
}

const FadeIn = keyframes`
  from {
    opacity: 0
  }
  to {
    opacity: 1
  }
`;

export const LoadingWrapper = styled.div<LoadingWrapperProps>`
  position: fixed;
  inset: 0;
  width: 100% !important;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  animation: ${FadeIn} 0.1s forwards;
  z-index: var(--modal-z);

  @media (min-width: 1366px) {
    width: 50.4vw;
  }

  ${({ isInner }) =>
    isInner &&
    css`
      width: 100% !important;
      height: 100% !important;
    `}

  ${({ backgroundOnly }) =>
    backgroundOnly &&
    css`
      background-color: rgba(0, 0, 0, 0);
    `}
`;
